export const PATH_LOGIN = '/login'
export const PATH_STATIONS = '/stations'
export const PATH_USER = '/users/info/'
export const PATH_USERS = '/users'
export const PATH_MOVEMENTS = '/movements'
export const PATH_MOVEMENTS_ADMISSIONS = '/movements-admissions'
export const PATH_MOVEMENT_TYPES = '/movements/types'
export const PATH_EXPORT_MOVEMENTS = '/movements/export'
export const PATH_REQUEST_MOVEMENTS = '/movements/requests'
export const PATH_SSCC_MOVEMENTS = '/movements/ssccs'
export const PATH_PALLET_TYPES = '/pallets/types'
export const PATH_PRODUCTS = '/products'
export const PATH_PRODUCT_TOLERANCE = '/products/tolerance'
export const PATH_STOCK_PRODUCTS = '/stocks/products'
export const PATH_PRODUCT_CATEGORY = '/products/categories'
export const PATH_PRODUCT_PACKAGING = '/products/packages'
export const PATH_PRODUCT_BATCH = '/movements/products/batch'
export const PATH_PRODUCT_CODE = '/movements/products/code'
export const PATH_CENTERS = '/centers'
export const PATH_STOCK = '/stocks'
export const PATH_STOCK_SSCC = '/stocks/ssccs'
export const PATH_STOCK_EXPORT = '/stocks/export'
export const PATH_STOCK_BATCH = '/stocks/batches'
export const PATH_ZONES = '/zones'
export const PATH_DELIVERIES = '/deliveries'
export const PATH_FILTERS = '/filters'
export const PATH_PRODUCTION_ORDER = '/production-orders'
export const PATH_RECODED_ORDER = '/recoded-orders'
export const PATH_REPACKAGED_ORDER = '/repackaged-orders'
export const PATH_CROSSDOCK_ORDER = '/crossdock-orders'
export const PATH_QUALITY_ORDERS = '/quality-orders'
export const PATH_CUSTOMERS = '/customers'
export const PATH_SHIPMENT_ORDER = '/shipment-orders'
export const PATH_CROSSDOCK_INBOUND_PALLETS = '/crossdock-inbound-pallets'
export const PATH_TRANSFER_ORDER = '/transfer-orders'
export const PATH_PRINTERS = '/printers'
